import React from 'react';
import { withTheme } from '@emotion/react';
import { ThemeProps } from '@theme/base';
import { Grid } from '@mui/material';
import { TripTypes, Page } from '@model/common';
import { VideoGuide } from '@model/content';
import { GuideLink } from '@components/common/next-link';
import { SimpleTile } from '@components/common/simple-tile';

export interface VideoGuideListProps extends ThemeProps {
  path: string;
  tripType?: TripTypes;
  guides: Array<VideoGuide>;
  destination?: string;
  testId?: string;
  className?: string;
  showList?: boolean;
}

export const VideoGuideListComponent = ({ path, guides, tripType, theme }: VideoGuideListProps) => {
  const renderVideoGuideTiles = () =>
    guides.map((videoGuide: VideoGuide) => {
      const { hero, title, shortDescription, targetPageConfigPath } = videoGuide;
      return (
        <Grid item xs={12} sm={6} lg={4} key={targetPageConfigPath}>
          <GuideLink path={path} guidePath={targetPageConfigPath} tripType={tripType} guidePage={Page.VIDEO_GUIDES}>
            <SimpleTile title={title} shortDescription={shortDescription} imageUrl={hero.url} />
          </GuideLink>
        </Grid>
      );
    });

  return (
    <Grid container spacing={theme!.custom.gridSpacing.default}>
      {renderVideoGuideTiles()}
    </Grid>
  );
};

export const VideoGuideList = withTheme(VideoGuideListComponent);
